import { TODAY_ISO_FORMAT } from '@philips-emr/hpms-health-insurance-components';
import { FetchAPI, FilterAPI, FormAPI } from '@philips-emr/tws-components';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

export default class FilterService {

  static restoreFilterState(event: MountEvent, parameters?: {}): void {
    const api = event.target as FilterAPI;
    const restore = api.restoreState(true);

    if (restore) return;

    api.setData({
      ...parameters,
    });
  }

  static restoreFormState(event: MountEvent, parameters?:{} ): void {
    const api = event.target as FormAPI;
    const restore = api.restoreState(true);

    if (restore) return;

    api.setRecord({
      datepicker: TODAY_ISO_FORMAT(),
      ...parameters });
  }

  static restoreFetchState(event: MountEvent, parameters?: {} ): void {
    const api = event.target as FetchAPI;
    const restore = api.restoreState(true);

    if (restore) return;
    api.setData({ ...parameters });
  }

  static persistState(event: MountEvent): void {
    event.target.persistState();
  }
}
